import { operatorClient } from 'domain/HttpClients';

export const fetch = (filters = {}) => operatorClient
  .Get('/api/transactions')
  .withParams(filters)
  .send();
